import React, { Component } from "react";
import { reduxForm } from "redux-form";
import { push } from "react-router-redux";
import Input from "../../../../components/form/Input";
import Button from "../../../../components/form/Button";
import Select from "../../../../components/form/Select";
import DatePicker from "../../../../components/form/DateTime";
import { ReduxCheckbox as Checkbox } from "../../../../components/form/Checkbox";
import CroField from "../generalForm/CroField";
import CroTiptapEditor from "../generalForm/CroTiptapEditor";
import { styles } from "../../index";
import { asyncForm } from "../../../../utils/asyncForm";
import * as V from "../../../../utils/formValidation";
import askAction from "../AskAction";
import { getFunctionaryNoticeTypes } from "../../CroActions";
import { dictToOptions } from "../../CroUtils";

import { EmailTemplatesType } from "../../enum";

const VARIABLE_DEFS_BY_TYPE = {
  INGOING_FORWARD: [
    { id: "officialFullName", label: "Jméno funkcionáře" },
    { id: "birthDate", label: "Datum narození" },
    { id: "birthCity", label: "Místo narození" },
    { id: "birthCountry", label: "Stát narození" },
    { id: "residenceAddress", label: "Adresa trvalého pobytu" },
    { id: "workingPosition", label: "Funkce" },
    { id: "ovmName", label: "Název OVM" },
    { id: "deadlineDate", label: "Termín odevzdání" },
    { id: "controlPeriod", label: "Kontrolní období" },
    { id: "todayDate", label: "Dnešní datum" },
    { id: "orpName", label: "Postoupení ORP" },
    { id: "internalName", label: "Zpracovatel" },
    { id: "internalPhone", label: "Telefon zpracovatele" },
    { id: "isMale", label: "Pohlaví funkcionáře (true/false)" },
    { id: "isAtOffence", label: "Funkcionář v prodlení" },
    { id: "dateStartEntry", label: "Datum nástupu" },
    { id: "reElected", label: "Znovuzvolen" },
    { id: "lateVariant", label: "Stav prodlení" },
    { id: "actualSubmissionDate", label: "Datum skutečného podání" },
  ],
  OUTGOING_FORWARD: [
    { id: "officialFullName", label: "Jméno funkcionáře" },
    { id: "birthDate", label: "Datum narození" },
    { id: "birthCity", label: "Místo narození" },
    { id: "birthCountry", label: "Stát narození" },
    { id: "residenceAddress", label: "Adresa trvalého pobytu" },
    { id: "workingPosition", label: "Funkce" },
    { id: "ovmName", label: "Název OVM" },
    { id: "deadlineDate", label: "Termín odevzdání" },
    { id: "controlPeriod", label: "Kontrolní období" },
    { id: "todayDate", label: "Dnešní datum" },
    { id: "orpName", label: "Postoupení ORP" },
    { id: "internalName", label: "Zpracovatel" },
    { id: "internalPhone", label: "Telefon zpracovatele" },
    { id: "isMale", label: "Pohlaví funkcionáře (true/false)" },
    { id: "isAtOffence", label: "Funkcionář v prodlení" },
    { id: "dateEndEntry", label: "Datum ukončení" },
    { id: "reElected", label: "Znovuzvolen" },
    { id: "lateVariant", label: "Stav prodlení" },
    { id: "actualSubmissionDate", label: "Datum skutečného podání" },
  ],
  ONGOING_FORWARD: [
    { id: "officialFullName", label: "Jméno funkcionáře" },
    { id: "birthDate", label: "Datum narození" },
    { id: "birthCity", label: "Místo narození" },
    { id: "birthCountry", label: "Stát narození" },
    { id: "residenceAddress", label: "Adresa trvalého pobytu" },
    { id: "workingPosition", label: "Funkce" },
    { id: "ovmName", label: "Název OVM" },
    { id: "deadlineDate", label: "Termín odevzdání" },
    { id: "controlPeriod", label: "Kontrolní období" },
    { id: "todayDate", label: "Dnešní datum" },
    { id: "orpName", label: "Postoupení ORP" },
    { id: "internalName", label: "Zpracovatel" },
    { id: "internalPhone", label: "Telefon zpracovatele" },
    { id: "isMale", label: "Pohlaví funkcionáře (true/false)" },
    { id: "isAtOffence", label: "Funkcionář v prodlení" },
    { id: "previousYear", label: "Předchozí rok" },
    { id: "periodFrom", label: "Začátek období" },
    { id: "periodTo", label: "Konec období" },
    { id: "organizationName", label: "Název organizace" },
    { id: "dateStartEntry", label: "Datum nástupu" },
  ],
};

class EmailTemplateForm extends Component {
  state = {
    functionaryNoticeTypeOptions: [],
  };

  async componentDidMount() {
    const noticeTypes = await getFunctionaryNoticeTypes(this.props.dispatch);
    this.props.breadcrumbs(this.props.breadcrumbsItems);
 
    this.setState({ functionaryNoticeTypeOptions: dictToOptions(noticeTypes.items) });
  }

  isTypeAppeals(type) {
    return type === "APPEAL_CREATE";
  }

  changedType = (typeId) => {
    const type = EmailTemplatesType.find((type) => type.id === typeId);
    this.props.change("subject", type && !this.isTypeAppeals(type.id) ? type.label : "");
    if(type && this.isTypeAppeals(type.id)) {
      this.props.change("fkFunctionalNoticeId", null);
    }
  }

  changedAppealType = (functionaryNoticeTypeId) => {
    this.props.change("subject", this.state.functionaryNoticeTypeOptions.find((noticeType) => noticeType.id === functionaryNoticeTypeId)?.label || "");
  }

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      onDelete,
      submitting,
      askAction,
      isNew,
      type,
      templateKeys
    } = this.props;

    const { functionaryNoticeTypeOptions } = this.state;

    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form long-label templateForm"
      >
        <div className="templateForm__section">
          <CroField
            title="Typ šablony"
            name="type"
            component={Select}
            items={EmailTemplatesType}
            disabled={!isNew}
            fullWidth
            onChange={this.changedType}
            validate={[V.required]}
          />
          {this.isTypeAppeals(type) && (
            <CroField
              title="Typ výzvy"
              name="fkFunctionalNoticeId"
              component={Select}
              items={functionaryNoticeTypeOptions}
              disabled={!isNew}
              fullWidth
              onChange={this.changedAppealType}
              validate={[V.required]}
            />
          )}
        </div>

        <div className="templateForm__section">
          <div className="templateForm__grid">
            <CroField
              className="third"
              title="Platnost od"
              name="validFrom"
              component={DatePicker}
              disabled={!isNew}
              noIcon
              fullWidth
              validate={[V.required]}
            />
            <CroField
              className="third"
              title="Platnost do"
              name="validTo"
              component={DatePicker}
              noIcon
              fullWidth
            />
            {!isNew && (<CroField
              className="third"
              title="Verze"
              name="version"
              component={Input}
              fullWidth
              disabled
            />)}
            {!isNew && (<CroField
              className="third"
              title="Publikováno"
              name="published"
              component={Checkbox}
              fullWidth
              disabled
            />)}
          </div>
        </div>

        <div className="templateForm__section templateForm__contentWrapper">
          <CroField
              className="third"
              title="Předmět emailu"
              name="subject"
              component={Input}
              fullWidth
          />

          <CroTiptapEditor
            title="Obsah emailu"
            name="content"
            fullWidth
            rows={20}
            validate={[V.required]}
            variables={VARIABLE_DEFS_BY_TYPE[type]}
          />

        </div>

        {templateKeys && templateKeys.length > 0 && (
            <div className="templateForm__templateKeys">
              <div className="hint">V obsahu šablony můžete využít placeholdery, které se při generování nahradí konkrétními hodnotami. K dispozici jsou placeholdery:</div>
              <ul>
                {templateKeys.map((key) => (
                    <li key={key.name}><b>{key.name}</b> = {key.description}</li>
                ))}
              </ul>
            </div>
        )}

        <div className="templateForm__footer">
            <div className="templateForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}
              <div className="templateForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>

              <div className="templateForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Zpět"
                  disabled={submitting}
                  onClick={() =>
                    this.props.dispatch(push(`/administrator/sablony/email`))
                  }
                />
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting}
                  onClick={handleSubmit(onSubmit)}
                />
                {!isNew && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Smazat"
                    disabled={submitting}
                    onClick={askAction(
                      onDelete,
                      "Opravdu chcete smazat tuto šablonu?",
                    )}
                  />
                )}
              </div>
            </div>
          </div>
      </form>
    );
  }
}

export default reduxForm({
  form: "emailTemplateForm",
})(askAction(asyncForm(EmailTemplateForm)));
